<!--
 * @Author: wzh
 * @LastEditTime: 2025-06-10 10:39:19
 * @Description: 登录页
-->
<template>
  <div
    class="login-container"
    :style="{
      '--defaultBg': coverImages.defaultBg,
      '--coverFile640': coverImages.coverFile640,
      '--coverFile768': coverImages.coverFile768,
      '--coverFile1024': coverImages.coverFile1024,
      '--coverFile1280': coverImages.coverFile1280,
      '--coverFile1536': coverImages.coverFile1536,
      '--coverFile1920': coverImages.coverFile1920,
    }"
  >
    <div class="login-header">
      <div class="header-logo">
        <img v-if="logoBase64" :src="logoBase64" @click="reload" />
      </div>
      <div class="header-text">{{ $t("login.title") }}</div>
      <div class="header-right">
        <span v-if="loginSetInfo.zxbz == 1" @click="handleHelp">帮助 | </span>
        <span>
          <a-dropdown>
            <a class="ant-dropdown-link" style="color: #ffffff"
              >{{ currentLanguage }} <a-icon type="down"
            /></a>
            <a-menu slot="overlay">
              <a-menu-item @click="languageChange('zh')">简体中文</a-menu-item>
              <a-menu-item @click="languageChange('en')">English</a-menu-item>
            </a-menu>
          </a-dropdown></span
        >
      </div>
    </div>
    <div class="login-body">
      <div class="login-box">
        <template v-if="loginType != 3">
          <div class="login-tab">
            <div class="tab-text">
              <span
                :class="{ active: loginType == 1 }"
                @click="loginTypeChange(1)"
              >
                {{ $t("login.type_account") }}</span
              >
              <span
                v-if="loginSetInfo.dtmdl == 1"
                class="two-way"
                :class="{ active: loginType == 2 }"
                @click="loginTypeChange(2)"
                >{{ $t("login.type_phone") }}</span
              >
            </div>

            <img
              v-if="loginSetInfo.smdl == 1"
              src="./image/graycode.png"
              class="code-icon"
              @click="loginTypeChange(3)"
            />
          </div>
          <a-form-model
            :model="formInline"
            :rules="rules"
            ref="loginForm"
            @submit.native.prevent
          >
            <template v-if="loginType == 1">
              <a-form-model-item>
                <a-input
                  @keyup.enter.native.stop="onSubmit"
                  v-model="formInline.username"
                  :placeholder="$t('login.username_placeholder')"
                >
                  <div slot="prefix">
                    <img src="./image/user.png" class="login-icon" />
                  </div>
                </a-input>
              </a-form-model-item>
              <a-form-model-item>
                <a-input-password
                  @keyup.enter.native.stop="onSubmit"
                  v-model="formInline.password"
                  :placeholder="$t('login.password_placeholder')"
                >
                  <div slot="prefix">
                    <img src="./image/sock.png" class="login-icon" />
                  </div>
                </a-input-password>
              </a-form-model-item>
              <a-form-model-item
                v-if="
                  (loginSetInfo.yzfs == 1 || loginSetInfo.yzfs == 3) &&
                  loginFailCount >= loginSetInfo.yzmcxsj
                "
              >
                <div class="row">
                  <a-input
                    @keyup.enter.native.stop="onSubmit"
                    v-model="formInline.captcha"
                    :placeholder="$t('base.captcha.placeholder')"
                  >
                    <div slot="prefix">
                      <img src="./image/pass.png" class="login-icon" />
                    </div>
                  </a-input>

                  <img
                    :src="validMaskImage"
                    class="ygm-img"
                    @click="getValidMask"
                  />
                </div>
              </a-form-model-item>
            </template>
            <template v-if="loginType == 2">
              <a-form-model-item>
                <a-input
                  @keyup.enter.native.stop="onSubmit"
                  v-model="formInline.mobile"
                  :placeholder="$t('base.mobile.placeholder')"
                >
                  <div slot="prefix">
                    <img src="./image/user.png" class="login-icon" />
                  </div>
                </a-input>
              </a-form-model-item>
              <a-form-model-item>
                <div class="row" style="align-items: center; gap: 10px">
                  <a-input
                    @keyup.enter.native.stop="onSubmit"
                    v-model="formInline.mobileCode"
                    :placeholder="$t('base.captcha.message_placeholder')"
                  >
                    <div slot="prefix">
                      <img src="./image/pass.png" class="login-icon" />
                    </div>
                    <div slot="suffix" class="suffix">
                      <span v-if="count == 60" @click="handleCode">{{
                        $t("base.btn.get_code")
                      }}</span>
                      <span v-else>{{ count }}s</span>
                    </div>
                  </a-input>
                </div>
              </a-form-model-item>
            </template>
            <div class="row">
              <a-form-model-item>
                <a-checkbox
                  v-if="loginSetInfo.qtmdl == 1"
                  v-model="remeberMe"
                  class="point-cursor"
                  >{{ $t("login.no_login") }}</a-checkbox
                >
              </a-form-model-item>
              <a-form-model-item>
                <span
                  v-if="loginSetInfo.zxbz == 1"
                  class="active point-cursor"
                  @click="handleHelp"
                  >{{ $t("login.online_help") }} |
                </span>
                <span
                  v-if="basicSetInfo.zhjh == 1"
                  class="active point-cursor"
                  @click="handleActive"
                  >{{ $t("login.account_activation") }} |
                </span>
                <span class="active point-cursor" @click="forgetPass"
                  >{{ $t("login.forget_password") }}?</span
                >
              </a-form-model-item>
            </div>
            <a-form-model-item>
              <a-button
                @click="onSubmit"
                type="primary"
                :loading="loginLoading"
                block
                class="login-btn"
                size="large"
              >
                {{ $t("login.login_btn") }}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </template>
        <template v-else>
          <div class="login-tab">
            <div class="title">
              <span>{{ $t("login.type_scan") }}</span>
            </div>
            <img
              src="./image/graypass.png"
              class="code-icon"
              @click="loginTypeChange(1)"
            />
          </div>
          <div class="scan-box">
            <!-- <div class="title">{{ $t("login.type_scan") }}</div> -->
            <a-spin :spinning="loading">
              <div class="scan-code" id="self_defined_element">
                <img src="./image/qrcode.png" />
              </div>
            </a-spin>

            <div class="scan-tip third-label">
              {{ $t("login.scan_app_left")
              }}<a>{{ $t("login.scan_app_name") }}</a
              >{{ $t("login.scan_app_right") }}
            </div>
          </div>
        </template>
        <template v-if="loginArr.length">
          <a-divider class="third-label">第三方账号登录</a-divider>
          <div class="third-icon-box">
            <img
              v-for="item in loginFormat"
              :alt="item.providerName"
              :title="item.providerName"
              :src="
                item.icon
                  ? require(`@/${item.icon}`)
                  : require('@/assets/images/social/default.png')
              "
              :key="item.id"
              @click="loginOk(item)"
            />
            <img
              v-if="loginMore.length"
              src="@/assets/images/social/more.png"
              @click="openMore"
            />
            <!-- <img src="./image/wx.png" alt="wechat" class="third-icon" />
            <img src="./image/qq.png" alt="wechat" class="third-icon" />
            <img src="./image/wb.png" alt="wechat" class="third-icon" /> -->
          </div>
        </template>
      </div>
    </div>
    <div class="login-bottom">
      <div class="copyright" v-if="copyrightInfo">{{ copyrightInfo }}</div>
    </div>
    <!-- 忘记密码弹窗 -->
    <Dialog
      :title="$t('login.forget_password')"
      ref="forgetPass"
      width="900px"
      class="none-footer"
      :noneFooter="true"
    >
      <forget @success="() => $refs.forgetPass.closeModal()" />
      <template slot="butList">
        <div></div>
      </template>
    </Dialog>

    <!-- 账号激活弹窗 -->
    <Dialog
      :title="$t('login.account_activation')"
      ref="accountActive"
      width="900px"
      class="none-footer"
    >
      <activate
        :basicSetInfo="basicSetInfo"
        @success="() => $refs.accountActive.closeModal()"
        :noneFooter="true"
      />
      <template slot="butList">
        <div></div>
      </template>
    </Dialog>

    <!-- 更多登录方式 -->
    <Dialog ref="moreLogin" title="更多登录方式" width="400px">
      <div class="more_login_type">
        <div class="item" v-for="item in loginMore" :key="item.id">
          <img
            v-if="item.icon"
            :src="require(`@/${item.icon}`)"
            @click="loginOk(item)"
          />
          <img
            v-else
            src="@/assets/images/social/default.png"
            @click="loginOk(item)"
          />
          <div @click="loginOk(item)">{{ item.providerName }}</div>
        </div>
      </div>
      <template slot="butList">
        <div></div>
      </template>
    </Dialog>
  </div>
</template>
<script>
import { commonAPI } from "@/apis";
import config from "@/config";
import { Dialog } from "@/components/public/dialog/ant";
import SelfVerify from "@/components/public/selfVerify/SelfVerify"; // 滑块
import { encryptAES, getUrlParam } from "@/utils";
import { currentLanguage } from "@/utils/helpers";
import { activate } from "@/views/activate"; // 账号激活组件
import { commonMethods } from "@/views/authPages/mixins/common";
import { forget } from "@/views/forget"; // 忘记密码组件
export default {
  name: "LoginPage",
  components: { Dialog, forget, activate, SelfVerify },
  mixins: [commonMethods],
  data() {
    return {
      bg1024: require("./image/bg1024.png"),
      formInline: {
        username: "",
        password: "",
        captcha: "",
        mobile: "",
        mobileCode: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: this.$t("login.username_placeholder"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.password_placeholder"),
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: this.$t("base.captcha.placeholder"),
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: this.$t("base.mobile.placeholder"),
            trigger: "blur",
          },
        ],
        mobileCode: [
          {
            required: true,
            message: this.$t("base.captcha.message_placeholder"),
            trigger: "blur",
          },
        ],
      },
      loginType: 1, // 登录类型 1，账号。2扫码
      validMaskImage: "", // 验证码
      stateToken: "", // 验证码返回的state 临时token
      basicSetInfo: {}, // 基础配置信息
      loginSetInfo: {}, // 登录配置信息
      verifyVisible: false, // 拼图弹窗
      loginFailCount: 0, // 登录失败次数
      remeberMe: false, // 七天免登陆
      loginLoading: false, // 登录按钮加载中
      count: 60, // 验证码倒计时
      copyrightInfo: "", // 版权
      logoBase64: "", // logo
      currentLanguage: "简体中文",
      loginArr: [], // 第三方登录方式
      loading: false,
      imgList: [
        "./image/bg.png",
        "./image/bg640.png",
        "./image/bg768.png",
        "./image/bg1024.png",
        "./image/bg1280.png",
        "./image/bg1536.png",
      ],
      imgCount: 0,
      coverImages: {
        coverFile640: "",
        coverFile768: "",
        coverFile1024: "",
        coverFile1280: "",
        coverFile1536: "",
        coverFile1920: "",
        defaultBg: "",
      },
    };
  },
  created() {
    this.currentLanguage = currentLanguage(true).text;
    this.getLoginSet();
    this.getBasicSet();
    this.getSafeSet();
    this.getValidMask();
    this.preLoad();
    this.getBqLogo();
    this.getLoginType();
  },
  computed: {
    loginFormat() {
      return this.loginArr; //.filter((o) => o && o.provider);
    },
    loginMore() {
      return []; // this.loginArr.filter((o) => o.isSystem != 1);
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
    preLoad() {
      if (this.imgCount >= this.imgList.length) {
        return;
      }

      const img = new Image();
      img.src = this.imgList[this.imgCount];
      img.onload = img.onerror = () => {
        this.imgCount++;
        this.preLoad();
      };
    },
    // 获取登录配置
    async getLoginSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/login/get"
      );
      if (code == 0) {
        let obj = { ...data };
        this.loginSetInfo = obj;
        sessionStorage.setItem("LOGIN_SET_INFO", JSON.stringify(obj));
      } else {
        this.$message.error(message);
      }
    },
    // 获取基础配置
    async getBasicSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/basic/get"
      );
      if (code == 0) {
        let obj = { ...data };
        this.basicSetInfo = obj;
        sessionStorage.setItem("BASIC_SET_INFO", JSON.stringify(obj));
      } else {
        this.$message.error(message);
      }
    },
    // 获取安全配置
    async getSafeSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/safe/get"
      );
      if (code == 0) {
        let obj = { ...data };
        sessionStorage.setItem("SAFE_SET_INFO", JSON.stringify(obj));
      } else {
        this.$message.error(message);
      }
    },
    // 获取版权、logo
    async getBqLogo() {
      const { code, data } = await commonAPI.getAction("/setting/logo/get");
      if (code == 0) {
        this.copyrightInfo = data.copyRight || "";
        this.logoBase64 = data.logoFileBase64 || "";
        const coverFile640 = await this.getLoginBg(data.coverFile640Id);
        const coverFile768 = await this.getLoginBg(data.coverFile768Id);
        const coverFile1024 = await this.getLoginBg(data.coverFile1024Id);
        const coverFile1280 = await this.getLoginBg(data.coverFile1280Id);
        const coverFile1536 = await this.getLoginBg(data.coverFile1536Id);
        const coverFile1920 = await this.getLoginBg(data.coverFile1920Id);

        this.coverImages.defaultBg = coverFile1024
          ? `url(${coverFile1024})`
          : `url(../${this.bg1024})`;
        this.coverImages.coverFile640 = coverFile640
          ? `url(${coverFile640})`
          : this.coverImages.defaultBg;
        this.coverImages.coverFile768 = coverFile768
          ? `url(${coverFile768})`
          : this.coverImages.defaultBg;
        this.coverImages.coverFile1024 = this.coverImages.defaultBg;
        this.coverImages.coverFile1280 = coverFile1280
          ? `url(${coverFile1280})`
          : this.coverImages.defaultBg;
        this.coverImages.coverFile1536 = coverFile1536
          ? `url(${coverFile1536})`
          : this.coverImages.defaultBg;
        this.coverImages.coverFile1920 = coverFile1920
          ? `url(${coverFile1920})`
          : this.coverImages.defaultBg;
      }
    },
    //获取背景图
    async getLoginBg(id) {
      if (!id) return;
      const rawBaseUrl = (config.SERVICES.BASE_URL || "").trim();
      const normalizedBaseUrl = /^https?:\/\//i.test(rawBaseUrl)
        ? rawBaseUrl.replace(/\/+$/, "")
        : `/${rawBaseUrl.replace(/^\.?\//, "").replace(/\/+$/, "")}`;
      return `${normalizedBaseUrl}/setting/basic/getBasicImgStream/${id}`;
    },
    // 登录切换
    loginTypeChange(key) {
      this.formInline = {
        username: "",
        password: "",
        captcha: "",
        mobile: "",
        mobileCode: "",
      };
      this.loginType = key;

      // author: wzh, date: 2023-07-03, for: 钉钉扫码登录
      if (key == 3) {
        this.loading = true;
        this.$nextTick(async () => {
          const { data } = await commonAPI.getAction(
            `/logon/oauth20/getConfig/dingtalk`,
            { url: "thirdLogin" }
          );
          DDLogin({
            id: "self_defined_element",
            goto: encodeURIComponent(
              `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${data.appid}&response_type=code&scope=snsapi_login&state=${data.state}&redirect_uri=${data.redirect_uri}`
            ),
            style: "border: none; background-color: #fff;",
            width: "100%",
            height: "300",
          });

          let handleMessage = (event) => {
            let origin = event.origin;
            if (origin == "https://login.dingtalk.com") {
              let loginTmpCode = event.data;
              window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${data.appid}&response_type=code&scope=snsapi_login&state=${data.state}&redirect_uri=${data.redirect_uri}&loginTmpCode=${loginTmpCode}`;
            }
          };

          if (typeof window.addEventListener != "undefined") {
            window.addEventListener("message", handleMessage, false);
          } else if (typeof window.attachEvent != "undefined") {
            window.attachEvent("onmessage", handleMessage);
          }
        });
      }
    },
    // 表单提交
    onSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (
            this.loginSetInfo.yzfs == 2 &&
            this.loginFailCount >= this.loginSetInfo.yzmcxsj
          ) {
            this.verifyVisible = true;
          } else {
            this.handleLogin();
          }
        } else {
          console.log(1);
          return false;
        }
      });
    },
    // 获取验证码
    async handleCode() {
      if (!this.formInline.mobile) {
        this.$message.warning(this.$t("base.mobile.placeholder"));
        return;
      }
      const { code, message } = await commonAPI.getAction(
        `/login/sendotp/${this.formInline.mobile}`
      );
      if (code == 0) {
        this.$message.success(message);
        // 开启倒计时
        this.count--;
        const timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.count = 60;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.$message.error(message);
      }
    },
    // 登录
    handleLogin() {
      const that = this;
      let redirect_uri = getUrlParam("redirect_uri");
      let params = {
        username: "",
        password: "",
        captcha: "",
        authType: "normal",
        state: this.stateToken,
        remeberMe: this.remeberMe ? "1" : "0",
        serviceUrl: redirect_uri ? this.getBase64(redirect_uri) : "",
      };
      if (this.loginType == 1) {
        params.username = this.formInline.username;
        params.password = this.formInline.password;
        params.captcha = this.formInline.captcha;
        params.authType = "normal";
      } else if (this.loginType == 2) {
        params.username = this.formInline.mobile;
        params.password = this.formInline.mobileCode;
        params.authType = "mobile";
      }
      this.loginLoading = true;
      const data = { ...params };
      data.password = encryptAES(params.password);
      this.$store
        .dispatch("auth/login", data)
        .then((res) => {
          this.loginLoading = false;
          if (res.code == 0) {
            let obj = {
              user: {
                username: res.data.username,
                displayName: res.data.displayName,
                email: res.data.email,
                mobile: res.data.mobile,
              },
              token: res.data.token,
            };
            this.$store.commit("auth/setUser", obj.user);
            this.$store.commit("auth/setToken", obj.token);

            if (res.data.remeberMe) {
              this.$cookies.set("REMEMBER_ME", obj, "7d");
            }
            if (typeof this.setLoginCookies === "function") {
              this.setLoginCookies(obj.token, obj.user);
            }
            if (redirect_uri) {
              sessionStorage.setItem("REDIRECT_URI", redirect_uri);
            }
            // accoutIsXm=true表示该账户处于休眠状态
            const isSleep = res.data.accoutIsXm === true;
            let before_login = {
              noSingleLogin: res.data.noSingleLogin,
              editPwd: res.data.editPwd,
              showInfo: res.data.showInfo,
              userInfoConfim: res.data.userInfoConfim,
              secAuth: res.data.secAuth,
              isSleep,
            };
            sessionStorage.setItem(
              "BEFORE_LOGIN",
              JSON.stringify(before_login)
            );
            // 如果账户处于休眠状态 存储账户和密码
            isSleep &&
              sessionStorage.setItem(
                "LOGIN_INFO",
                JSON.stringify({
                  account: this.formInline.username,
                  password: this.formInline.password,
                })
              );

            if (
              data.unusualAddressLoginPrompt &&
              data.unusualAddressLoginPrompt != ""
            ) {
              this.$confirm({
                title: "温馨提示",
                content: res.data.unusualAddressLoginPrompt,
                onOk() {
                  that.jumpComputed();
                },
                onCancel() {
                  that.$store.dispatch("auth/loginOut");
                },
              });
            } else {
              this.jumpComputed();
            }
          } else {
            this.$message.error(res.message);
            this.loginFailCount = res.data.loginFailCount; // 登录失败次数
            this.getValidMask(); // 如果没成功则重新生成新的验证码
          }
        })
        .catch((err) => {
          console.log("err :>> ", err);
          // this.$message.error(err);
        });
    },
    // 得到验证码图片
    async getValidMask() {
      const { code, data } = await commonAPI.getAction("/captcha");
      if (code === 0) {
        this.validMaskImage = data.image;
        this.stateToken = data.state;
      }
    },
    // 激活弹窗
    handleActive() {
      this.$refs.accountActive.openModal();
    },
    // 打开忘记密码弹窗
    forgetPass() {
      this.$refs.forgetPass.openModal();
    },

    // author: wzh, date: 2023-05-29, for: 帮助文档 跳转修改
    handleHelp() {
      if (this.loginSetInfo.iszxbzwd == 1) {
        let routeUrl = this.$router.resolve({ path: "/help" });
        window.open(routeUrl.href, "_blank");
      } else if (this.loginSetInfo.istzdz == 1) {
        window.open(this.loginSetInfo.tzdz);
      }
    },

    // 关闭验证
    slideClose() {
      this.verifyVisible = false;
    },
    // 滑块验证成功
    slideSuccess() {
      this.verifyVisible = false;
      this.handleLogin();
    },
    // author: wzh, date: 2023-01-06, for: 语言切换
    languageChange(type) {
      let obj =
        type == "zh"
          ? { value: "zh", text: "简体中文" }
          : { value: "en", text: "English" };
      this.currentLanguage = obj.text;
      this.$i18n.locale = type;
      localStorage.setItem("language", JSON.stringify(obj));
      this.$bus.emit("change_lang");
    },

    // author: wzh, date: 2023-05-30, for: 获取联合登录方式
    async getLoginType() {
      const { code, data } = await commonAPI.getAction(
        "/login/socialsprovider/listToLogin"
      );
      if (code == 0 && Array.isArray(data)) {
        // 过滤掉无效的数据
        this.loginArr = data.filter((item) => item && typeof item === "object");
      } else {
        this.loginArr = [];
      }
    },

    // 更多登录方式弹窗
    openMore() {
      this.$refs.moreLogin.openModal();
    },

    // 第三方登录点击
    async loginOk(item) {
      const { code, data, message } = await commonAPI.getAction(
        `/logon/oauth20/authorize/${item.provider}`,
        {
          url: "thirdLogin",
        }
      );
      if (code == 0) {
        // let redirect_uri = this.$route.query.redirect_uri;
        let redirect_uri = getUrlParam("redirect_uri");

        if (redirect_uri) {
          // console.log('redirect_uri ---- 1', redirect_uri);
          sessionStorage.setItem("REDIRECT_URI", redirect_uri);
        }
        window.location.href = data;
      } else {
        this.$message.error(message);
      }
    },
  },
};
</script>
<style></style>
<style lang="scss" scoped>
$primary-color: var(--primary-color);
$active-color: #0346dd;
$default-color: #ffffff;
$gray-color: #999999;
$black-color: #000000;
$header-height: 94px;
$bottom-height: 94px;
$header-bg-color: rgba(0, 0, 0, 0.6);
$bottom-bg-color: rgba(0, 0, 0, 0.6);
$header-text-color: #ffffff;
$bottom-text-color: #ffffff;
$body-bg-color: rgba(255, 255, 255, 0.8);
$xl-font-size: 26px;
$lg-font-size: 20px;
$m-font-size: 16px;
$xs-font-size: 14px;

::v-deep {
  .ant-form-item {
    margin-bottom: 0;
    margin-top: 22px;
  }

  .ant-spin-blur {
    border-radius: 4px;
  }

  .ant-checkbox-inner {
    width: 20px !important;
    height: 20px !important;
  }

  .login-box {
    .ant-input {
      height: 70px;
      font-size: $lg-font-size;

      &-affix-wrapper .ant-input:not(:first-child) {
        padding-left: 54px;
      }

      &-suffix {
        font-size: $lg-font-size;
      }
    }
  }

  .ant-btn-lg {
    padding: 10px auto;
  }
}

.point-cursor {
  cursor: pointer;
  font-size: $lg-font-size;
}

.login-container {
  display: grid;
  grid-template-rows: $header-height 1fr $bottom-height;
  width: 100%;
  height: 100%;
  min-height: 688px;
  overflow: hidden;
  background-image: var(--defaultBg);
  background-repeat: no-repeat;
  transition: all 0.3s ease;
  background-size: 100% 100%;

  .login-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: relative;
    color: $header-text-color;
    background: $header-bg-color;

    .header-text {
      font-size: $lg-font-size;
      flex: 1;
      padding-left: 50px;
      box-sizing: content-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .header-logo {
      height: 85px;
      width: 400px;
      margin-left: 3%;
      flex-shrink: 0;
      cursor: pointer;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        // object-fit: contain;
      }
    }

    .header-right {
      flex-shrink: 0;
      cursor: pointer;
      font-size: $m-font-size;
      font-weight: 400;
      margin-right: 3%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .login-body {
    position: relative;

    padding: 50px 0;
    box-sizing: content-box;

    .login-box {
      position: absolute;
      background: $body-bg-color;
      top: 50%;
      transform: translateY(-50%);
      transition: all ease 0.3s;

      .login-tab {
        cursor: pointer;
        height: 58px;
        position: relative;

        .code-icon {
          position: absolute;
          right: -10px;
          z-index: 1;
          width: 80px;
          height: 100%;
          object-fit: contain;
          margin-bottom: 10px;
        }

        .title {
          position: absolute;
          bottom: 10px;
          font-weight: 600;
          width: 100%;
          margin: 0 auto;
          text-align: center;
          color: $black-color;
        }

        .tab-text {
          position: absolute;
          bottom: 10px;
          font-weight: 600;
          width: 100%;
          margin: 0 auto;
          color: $black-color;

          .two-way {
            margin-left: 60px;
          }
        }
      }

      .third-icon-box {
        display: flex;
        justify-content: space-evenly;
        img {
          width: 38px;
          height: 38px;
          cursor: pointer;
        }
      }

      .third-icon {
        object-fit: contain;
        cursor: pointer;
      }

      .login-btn {
        background: $primary-color;
        border-color: $primary-color;
      }

      .third-label {
        color: $gray-color;
        text-align: center;
      }

      .row {
        display: flex;
        justify-content: space-between;
      }

      .suffix {
        color: $gray-color;
        font-size: $m-font-size;
        cursor: pointer;
      }

      .ygm-img {
        border-radius: 4px;
        margin-left: 6px;
      }

      .login-icon {
        object-fit: contain;
        margin-left: 6px;
      }

      .scan-box {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding: 40px;

        .scan-code {
          width: 200px;
          height: 200px;

          border: solid 1px #cccccc;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          border-radius: 4px;
          position: relative;
          overflow: hidden;

          img {
            max-width: 190px;
            max-height: 190px;
          }

          &::after {
            width: 100%;
            height: 100%;
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.9);
          }
        }

        .scan-tip {
          margin-top: 20px;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .login-box {
        width: 423px;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .suffix {
        font-size: $xs-font-size !important;
      }
    }

    .active {
      color: $primary-color;
      transition: all 0.1s ease;
    }
  }

  .login-bottom {
    width: 100%;
    color: $bottom-text-color;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    .copyright {
      width: 100%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: $bottom-bg-color;
    }
  }
}

// 媒体查询中的重复代码
@mixin responsive-styles {
  // background-image: none;

  .login-container {
  }

  .login-box {
    width: 423px;
    padding: 10px 15px 15px 15px;
    border-radius: 8px;
    box-sizing: border-box;

    .title {
      font-size: $m-font-size;
    }
    .login-tab {
      .tab-text {
        font-size: $m-font-size;
        text-align: center;
      }
    }

    .login-icon {
      height: 20px;
    }

    .ygm-img {
      height: 52px;
    }

    .point-cursor {
      font-size: $xs-font-size;
    }

    .login-btn {
      height: 44px;
      font-size: $m-font-size;
    }

    .third-label {
      font-size: $xs-font-size;
    }

    .third-icon {
      width: 35px;
      height: 35px;
    }

    .third-icon-box {
      // gap: 50px;
      margin-top: 10px;
    }
  }

  /deep/ .login-box .ant-input {
    height: 52px;
    font-size: $m-font-size;
  }

  /deep/ .ant-form-item {
    margin-top: 16px;
  }

  /deep/ .login-box .ant-input-affix-wrapper .ant-input:not(:first-child) {
    padding-left: 44px;
  }
}

@media screen and (max-width: 640px) {
  .login-container {
    @include responsive-styles;
    background-image: var(--coverFile640);
  }
}

@media screen and (min-width: 640px) and (max-width: 768px) {
  .login-container {
    @include responsive-styles;
    background-image: var(--coverFile768);
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .login-container {
    @include responsive-styles;
    background-image: var(--coverFile1024);

    .login-box {
      right: 112px;
    }
  }
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .login-container {
    @include responsive-styles;
    background-image: var(--coverFile1280);

    .login-box {
      right: 56px;
    }
  }
}

@media screen and (min-width: 1280px) and (max-width: 1536px) {
  .login-container {
    @include responsive-styles;
    background-image: var(--coverFile1536);

    .login-box {
      right: 312px;
    }
  }
}

@media screen and (min-width: 1536px) {
  .login-container {
    background-image: var(--coverFile1920);

    .login-box {
      width: 575px;
      padding: 7px 15px 15px 15px;
      border-radius: 8px;
      right: 385px;

      .login-tab {
        height: 78px !important;

        .title {
          font-size: $lg-font-size;
        }

        .tab-text {
          font-size: $lg-font-size;
          text-align: left;
        }

        .code-icon {
          right: 0px !important;
        }
      }

      .login-icon {
        height: 20px;
      }

      .ygm-img {
        height: 70px;
      }

      .point-cursor {
        font-size: $m-font-size;
      }

      .login-btn {
        height: 70px;
        font-size: $lg-font-size;
      }

      .third-label {
        font-size: $m-font-size;
      }

      .third-icon {
        width: 48px;
        height: 48px;
      }

      .third-icon-box {
        // gap: 50px;
        margin-top: 10px;
      }
    }
  }

  /deep/ .login-box .ant-input {
    height: 70px !important;
    border-radius: 6px;
    font-size: $lg-font-size;
  }
}
</style>
